import { render, staticRenderFns } from "./EmployeeRolesModal.vue?vue&type=template&id=8d3c0fbe&scoped=true&"
import script from "./EmployeeRolesModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeRolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3c0fbe",
  null
  
)

export default component.exports